export function validateCheckout() {
	const elements = document.getElementsByClassName( 'react-digital-code-delivery-options' );
	if ( ! elements.length ) {
		changeProceedLink( false );
		return;
	}

	let isCheckoutBtnDisabled = false;
	for ( let i = 0; i < elements.length; i++ ) {
		if ( 'false' === elements[ i ].dataset.isSelected ) {
			isCheckoutBtnDisabled = true;
		}
	}

	changeProceedLink( isCheckoutBtnDisabled );
}

function changeProceedLink( disabile ) {
	const checkoutElement = document.getElementsByClassName( 'proceed-to-checkout' );
	if ( ! checkoutElement.length ) {
		return;
	}
	const link = checkoutElement[ 0 ].querySelector( 'a' );
	if ( disabile ) {
		link.classList.add( 'pointer-event-disabled' );
		link.classList.add( 'disabled' );
	} else {
		link.classList.remove( 'pointer-event-disabled' );
		link.classList.remove( 'disabled' );
	}
}

export function updateDeliveryIsSelected( key, value ) {
	const el = document.getElementById( 'react-digital-code-delivery-options-' + key );
	el.dataset.isSelected = value;
}

export function closeOverlay( dispatch, state ) {
	const { shipment, isConfirmedCloseVisible, isSaved, selectedDistributionMethod } = state;
	if ( ! shipment || isConfirmedCloseVisible || isSaved ) {
		dispatch( {
			type: 'SET_OVERLAY_VISIBILITY',
			payload: false,
		} );
		dispatch( {
			type: 'SET_NOTIFY',
			payload: {
				class: '',
				msg: '',
			},
		} );
		dispatch( {
			type: 'SET_CONFIRMED_CLOSE_VISIBILITY',
			payload: false,
		} );

		if ( selectedDistributionMethod ) {
			dispatch( {
				type: 'SET_STEP',
				payload: 'savedData',
			} );
		}
	} else {
		dispatch( {
			type: 'SET_CONFIRMED_CLOSE_VISIBILITY',
			payload: true,
		} );
		dispatch( {
			type: 'SET_NOTIFY',
			payload: {
				class: 'error',
				msg: 'Om du stänger ner rutan utan att ha sparat så kommer dina ändringar att förloras.',
			},
		} );
	}
}

export const setDeliveryOptionButtonSelected = itemKey => {
	replaceDeliveryOptionBtn( itemKey );
};

export const replaceDeliveryOptionBtn = itemKey => {
	document.getElementById( 'react-digital-code-delivery-options-btn-' + itemKey ).innerHTML = document.getElementsByClassName( 'delivery-selected-content' )[ 0 ].innerHTML;
};
